import { render, staticRenderFns } from "./productfullfilment.vue?vue&type=template&id=7d5ba39d&"
import script from "./productfullfilment.vue?vue&type=script&lang=js&"
export * from "./productfullfilment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports